<div style="margin-bottom:30px; padding:20px; border:1px solid #000000;" *ngIf="userProfile">

	<h2 class="cpo-section-title">Profile</h2>

	<app-textbox label="First Name" [(ngModel)]="userProfile.firstName"></app-textbox>
	<app-textbox label="Last Name" [(ngModel)]="userProfile.lastName"></app-textbox>
	<app-textbox label="Email Address" [type]="InputTextModes.Email" [(ngModel)]="userProfile.email" [disabled]="true"></app-textbox>
	<app-textbox label="Phone Number" [type]="InputTextModes.Phone" [(ngModel)]="userProfile.phone"></app-textbox>

	<div style="display: flex; gap: 20px; justify-content: center; padding: 20px 0px 0px 0px;">
		<button class="btn-secondary" style="width: 150px;" (click)="this.btnCancelProfileClick()"> Cancel </button>
		<button class="btn-primary" style="width: 150px;" (click)="this.btnSaveProfileClick()" [disabled]="userProfile?.firstName === cachedUserProfile?.firstName && userProfile?.lastName === cachedUserProfile?.lastName && userProfile?.phone === cachedUserProfile?.phone"> Save </button>
	</div>

</div>

<div style="padding:20px; border:1px solid #000000;">

	<h2 class="cpo-section-title">Password</h2>

	<div *ngIf="usesGoogleAuth && !usesPasswordAuth">
		<p>You are using Google authentication. You cannot change your password.</p>
	</div>

	<div *ngIf="usesGoogleAuth && usesPasswordAuth">
		<p>It looks like you might be using Google authentication instead of a password.</p>
	</div>

	<div *ngIf="usesPasswordAuth">

		<app-textbox label="Current Password" type="Password" [(ngModel)]="currentPassword"></app-textbox>
		<app-textbox label="New Password" type="Password" [(ngModel)]="newPassword"></app-textbox>
		<app-textbox label="Confirm New Password" type="Password" [(ngModel)]="confirmNewPassword"></app-textbox>

		<div style="display: flex; gap: 20px; justify-content: center; padding: 20px 0px 0px 0px;">
			<button class="btn-secondary" style="width: 150px;" (click)="this.btnCancelPasswordClick()"> Cancel </button>
			<button class="btn-primary" style="width: 150px;" (click)="this.btnSavePasswordClick()"> Save </button>
		</div>
	</div>

</div>